"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-spring-manufacturing";
const IMAGE_SRC = "/image/new-version/more/SpringManufacturing/key-advantages-of-custom-spring-manufacturing.webp";

const ADVANTAGES = [
	"advantagesItem1",
	"advantagesItem2",
	"advantagesItem3",
	"advantagesItem4",
	"advantagesItem5",
	"advantagesItem6",
] as const;

export default function SpringManufacturingAdvantages() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="mb-6 sm:mb-8 md:mb-10 lg:mb-12">
					<span className="mb-3 inline-block text-xl uppercase tracking-wider text-themePrimary400 max-md:text-lg">
						{t("advantagesEyebrow")}
					</span>
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("advantagesTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("advantagesDesc")}</p>
				</div>

				<div className="grid items-center gap-8 lg:grid-cols-[5fr_6fr] lg:gap-12">
					<div className="relative aspect-[4/4.6] overflow-hidden bg-[#f5f7fa] sm:aspect-[4/3] lg:aspect-[4/4.6]">
						<Image
							src={IMAGE_SRC}
							alt={t("advantagesImageAlt")}
							fill
							className="object-cover"
							sizes="(max-width: 1024px) 100vw, 45vw"
						/>
					</div>

					<div className="space-y-5">
						{ADVANTAGES.map((item) => (
							<div key={item} className="flex gap-4">
								<span className="mt-1 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-themePrimary400 text-sm font-bold text-white">
									<svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
									</svg>
								</span>
								<div>
									<h3 className="mb-2 text-base font-bold text-black sm:text-lg md:text-xl">
										{t(`${item}Title`)}
									</h3>
									<p className="text-sm leading-relaxed text-black md:text-base">{t(`${item}Desc`)}</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
